<template>
    <BaseModal ref="modal"
        @cancel="cancel" @confirm="triggerSubmit"
        v-model="isModalOpen"
        :title="title"
        :confirmButton="computedConfirmButton"
        :cancelButton="computedCancelButton"
        max-width="330px"
        persistent
    >
        <CustomerForm
            ref="customer_form"
            v-if="!loading"
            v-model="customer"
            :isFormValid.sync="isFormValid"
            :useCNPJ="useCNPJ"
            :formType="'EDIT'"
            @submit="confirm"
            @triggerSubmit="triggerSubmit"
            :loading="loading"
        />
        <span v-else>{{ $t('forms.wait') }}</span>
    </BaseModal>
</template>

<script>
import CustomerForm from '@/components/forms/CustomerForm'
import BaseModal from '@/components/modals/BaseModal'
import BaseModalMixin from '../BaseModalMixin'
import Customer from '@/models/Customer'

export default {
    name: 'CustomersCreateModal',
    mixins: [ BaseModalMixin ],
    components: { BaseModal, CustomerForm },
    props: {
        customer: {
            type: Customer,
            required: true,
        },
    },
    data: vm => {
        return {
            isFormValid: false,
            title: vm.$t('views.customers.Create.title'),
            loading: false,
        }
    },
    methods: {
        triggerSubmit() {
            this.$refs.customer_form.submit()
        },
        async beforeConfirm(customer) {
            if (!this.isFormValid)
                return false

            this.loading = true
            customer.firebaseAction = 'UPDATE'

            if (customer.password_update)
                customer.password = customer.password_update

            if (customer.password == 'justForValidation')
                delete customer.password

            customer.formatToBack()

            let errType
            let response = await customer.update()
                .catch(err => {
                    if (err.message == 'Network Error') {
                        errType = 'network_error'
                        return 
                    }

                    if (err.response.data.type) {
                        errType = err.response.data.type
                        return
                    }

                    errType = 'error'
                })

            this.customer.formatToFront()
            
            if (errType) {
                this.loading = false
                customer.password = ''
                customer.confirmation_password = ''
                customer.password_update = ''
                customer.confirmation_password_update = ''
                const definedErrors = [
                    'used_email',
                    'used_phone',
                    'used_document',
                    'error_get',
                    'network_error'
                ]
                errType = definedErrors.includes(errType) ? errType : 'error'
                await new Promise((resolve) => {
                    this.$bus.$emit('alert', this.$t(`views.customers.Edit.alerts.${errType}`), 'error', resolve)
                })
                return false
            }

            this.customer.formatToFront()
            this.loading = false

            this.resolveValue = this.customer
            return true
        },
    },
    computed: {
        useCNPJ() {
            this.customer.useCNPJ = Customer.determineUseCNPJ(this.customer.document)
            return this.customer.useCNPJ
        },
        computedConfirmButton() {
            return {
                label: this.$t('actions.save'),
                disabled: !this.isFormValid,
                loading: this.loading,
            }
        },
        computedCancelButton() {
            return {
                disabled: this.loading,
            }
        },
    },
}
</script>